import {
  FETCH_PROFILE_DETAILS_FAILURE,
  FETCH_PROFILE_DETAILS_REQUEST,
  FETCH_PROFILE_DETAILS_SUCCESS,
  UPDATE_PROFILE_SUCCESS,
} from "../constants";
import profileMapper from "../../../pages/editProfile/profileMapper";

const INITIAL_STATE = {
  profileDetails: [],
  isLoading: false,
};

const profileReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_PROFILE_DETAILS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_PROFILE_DETAILS_FAILURE:
      return {
        ...state,
        isLoading: false,
        profileDetails: [],
      };
    case FETCH_PROFILE_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        profileDetails: profileMapper(action.payload),
      };
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        profileDetails: action.payload,
      };
    default:
      return state;
  }
};

export default profileReducer;
